import { Injectable } from '@angular/core';

import type { IComposePanelAttachment } from '../models/compose.models';

/**
 * Registry of in-flight draft attachment uploads by panelId and attachment key.
 * Used to abort a specific upload when the user removes that attachment.
 */
@Injectable({ providedIn: 'root' })
export class DraftAttachmentUploadRegistry {
  private readonly map = new Map<string, AbortController>();

  private key(panelId: string, att: IComposePanelAttachment): string {
    return `${panelId}:${att.name}:${att.size}`;
  }

  register(panelId: string, att: IComposePanelAttachment, controller: AbortController): void {
    this.map.set(this.key(panelId, att), controller);
  }

  abortAndRemove(panelId: string, att: IComposePanelAttachment): void {
    const k = this.key(panelId, att);
    const controller = this.map.get(k);
    if (controller) {
      controller.abort();
      this.map.delete(k);
    }
  }

  unregister(panelId: string, att: IComposePanelAttachment): void {
    this.map.delete(this.key(panelId, att));
  }
}
